// step3 名前の警告表示
export const warnName = (name) => {
  const rtn = { value: false }
  const keywords = [
    '請求書なし',
    '営業所',
    'センター',
    '請求書',
    '郵便局'
  ]

  // いずれかのキーワードが存在するならば
  if (keywords.some(key => name.includes(key))) {
    rtn.value = true
  }

  return rtn.value
} 

// step3 住所の警告表示
export const warnAddress = (_address) => {
  const address = hankaku2Zenkaku(_address)
  const rtn = { value: false }

  // アルファベットが１文字でもあるならば
  if(address.match(/[A-Za-z]/) !== null){
    rtn.value = true
  }

  const keywords = [
    '営業所',
    'センター',
    '留め',
    '止め',
    '営業所',
    '領収',
    '郵便局',
    'ヤマト'
  ]
  // いずれかのキーワードが存在するならば
  if (keywords.some(key => address.includes(key))) {
    rtn.value = true
  }
  // 数値が１つもないならば
  if (address.length > 0) {
    if(address.match(/[0-9]/) === null){
      rtn.value = true
    }
  }

  return rtn.value
}

const hankaku2Zenkaku = (str) => {
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
  })
}